import { render, staticRenderFns } from "./df-product-details-images.vue?vue&type=template&id=2bd68648&"
import script from "./df-product-details-images.ts?vue&type=script&lang=js&"
export * from "./df-product-details-images.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports